import { useState } from "react";
import { detectPhoneDevice } from "../utils/phoneDevice.js";

export function usePhoneDevice() {
  const [isPhone] = useState(() => detectPhoneDevice());
  return isPhone;
}
